import React from "react";
import "./style.css";

export default function PriceSync({ data, handleOnClick }) {
  return (
    <div className="inventory_sync_bg">
      <p className="inventory_sync_head">Price Synchronization</p>

      <div className="inventory_sync_option_row">
        <div>
          <label className="modern_toggle">
            <input
              type="checkbox"
              checked={data.priceSync.amazon}
              onChange={() =>
                handleOnClick("priceSync", "amazon", !data.priceSync.amazon)
              }
            />
            <span className="toggle_slider"></span>
          </label>
          <p>Amazon</p>
        </div>

        <div>
          <label className="modern_toggle">
            <input
              type="checkbox"
              checked={data.priceSync.shopify}
              onChange={() =>
                handleOnClick("priceSync", "shopify", !data.priceSync.shopify)
              }
            />
            <span className="toggle_slider"></span>
          </label>
          <p>Shopify</p>
        </div>
      </div>
    </div>
  );
}
